import React, { useState } from 'react';
import { Offcanvas, Button } from 'react-bootstrap';
import ItemDetail from '../ItemDetail/ItemDetail';
import "../Item/item.css";
import { useCartContext } from '../Context/CartContext';

const Item = ({ item }) => {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const { currentPrice } = useCartContext();
  const handleShow = () => setShowOffcanvas(true);
  const handleClose = () => setShowOffcanvas(false);

  return (
    <>
      {/* 🔥 Tarjeta del combo */}
      <div className="card" style={{ cursor: 'pointer', position: 'relative' }}>
        {item.promocion === 'si' && (
          <div className="promo-badge">En Promo!</div>
        )}
        <img
          className="card-img-top"
          src={item.image}
          alt="Productos de la web"
          style={{ height: '100%', width: '250px', margin: '0 auto' }}
        />
        <div className="card-body">
          <h5 className="card-title">- Combo: {item.name}</h5>
          {/* 🔥 Botón de Ver Más */}
          <Button variant="outline-light" className="item-btn" onClick={handleShow}>
            Ver Más 👀
          </Button>
        </div>
      </div>

      {/* 🔥 Offcanvas (panel lateral) para mostrar `ItemDetail` con tema oscuro */}
      <Offcanvas show={showOffcanvas} onHide={handleClose} placement="start" className="offcanvas-dark">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Detalle del Combo</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="offcanvas-body-dark">
          <ItemDetail item={item} />
        </Offcanvas.Body>
        <div className="p-3 text-center">
          <Button variant="light" onClick={handleClose}>
            Cerrar
          </Button>
        </div>
      </Offcanvas>
    </>
  );
};

export default Item;
